export const photonWebVersion = "1.1.23";		/// <change version script>
